import { GraphQLClient } from 'graphql-request';
import { getSdk } from 'generated/graphql';

const MUMS_QUERY_KEY = 'MUMS';
const MUMS_ENDPOINT = '/graphql';
const graphQLClient = new GraphQLClient(MUMS_ENDPOINT);
const MumsAPI = getSdk(graphQLClient);

export { MumsAPI, MUMS_QUERY_KEY };
